import scratch01 from '../img/CentroInnovacion/scratch01.jpg';
import scratch02 from '../img/CentroInnovacion/scratch02.jpg';
import scratch03 from '../img/CentroInnovacion/scratch03.jpg';
import scratch04 from '../img/CentroInnovacion/scratch04.jpg';
import scratch05 from '../img/CentroInnovacion/scratch05.jpg';
import scratch06 from '../img/CentroInnovacion/scratch06.jpg';
import scratch07 from '../img/CentroInnovacion/scratch07.jpg';
import scratch08 from '../img/CentroInnovacion/scratch08.jpg';
import scratch09 from '../img/CentroInnovacion/scratch09.jpg';
import scratch10 from '../img/CentroInnovacion/scratch10.jpg';
import scratch11 from '../img/CentroInnovacion/scratch11.jpg';
import miVideo from '../img/CentroInnovacion/scratch12.mp4';


const proyectos = [

{
    id: 1, 
    categoria: "Programación",
    titulo: "Creación de Animaciones",
    descripcion: "Los alumnos desarrollaron personajes, escenarios y efectos utilizando bloques de programación visual.",
    archivo: scratch01,
    link: ""
},

{
    id: 2,
    categoria: "Programación",
    titulo: "Introducción a Scratch",
    descripcion: "Nuestros estudiantes comenzaron a descubrir el mundo de la programación mediante el uso de Scratch, creando sus primeras animaciones y secuencias interactivas.",
    archivo: scratch02,
    link: ""
},

{
    id: 3,
   categoria: "Programación",
    titulo: "Primeros Videojuegos",
    descripcion: "Aplicando variables, movimientos y eventos, los estudiantes construyeron sus primeros videojuegos.",
    archivo: scratch03,
    link: ""
},

{
    id: 4,
    categoria: "Programación",
    titulo: "Primeros Videojuegos",
    descripcion: "Aplicando variables, movimientos y eventos, los estudiantes construyeron sus primeros videojuegos.",
    archivo: scratch04,
    link: ""
},

{
    id: 5,
    categoria: "Pensamiento Computacional",
    titulo: "Resolución de Problemas",
    descripcion: "Mediante desafíos de programación, los estudiantes fortalecen el pensamiento lógico y la resolución de problemas.",
    archivo: scratch05,
    link: ""
},

{
    id: 6,
    categoria: "Creatividad Digital",
    titulo: "Diseño de Proyectos",
    descripcion: "Cada estudiante desarrolla proyectos originales integrando creatividad, programación y trabajo colaborativo.",
    archivo: scratch06,
    link: ""
},

{
    id: 7,
    categoria: "Innovación",
    titulo: "Aprendiendo Programación",
    descripcion: "El Centro de Innovación promueve el desarrollo de habilidades digitales para enfrentar los desafíos del siglo XXI.",
    archivo: scratch07,
    link: ""
},

{
    id: 8,
    categoria: "Scratch",
    titulo: "Presentación de Proyectos",
    descripcion: "Los estudiantes presentan y comparten sus proyectos con la comunidad educativa, fortaleciendo la comunicación y el trabajo en equipo.",
    archivo: scratch08,
    link: ""
},

{
    id: 9,
    categoria: "Scratch",
    titulo: "Programación Juego Todos al Mar",
    descripcion: "Los estudiantes de 3° básico programan juego y realizan sus propias personalización del juego",
    archivo: scratch09,
    link: ""
},

{
    id: 10,
    categoria: "Scratch",
    titulo: "Programación Juego a trapame si puedes",
    descripcion: "Los estudiantes de 3° básico programan juego de una nave espacial y un extraterreste",
    archivo: scratch10,
    link: ""
},

{
    id: 11,
    categoria: "Scratch",
    titulo: "Programación Juego Nave y Asteroides",
    descripcion: "Los estudiantes de 7° básico programan juego de una nave espacial que destruye Asteroides",
    archivo: scratch11,
    link: ""
},


//Ejemplo para poner un video de youtube

/*{
    id: 12,
    categoria: "Video",
    titulo: "Proyecto de Programación",
    descripcion: "Nuestros estudiantes presentan su proyecto.",
    type: "youtube",
    link: "https://www.youtube.com/watch?v=XXXXXXXXXXX"
},*/


//ejemplo para poner un video mp4  el video debe estar en esta ruta : src/img/CentroInnovacion/

{
    id: 12,
    categoria: "Programación en Scratch",
    titulo: "Programación Juego Nave y Asteroides",
    descripcion: "Video de nuestra actividad alumnos de 7° Básico",
    archivo: miVideo,
    type: "video",
    link: ""
},


// Para los Archivis PDf 

/*{
    id: 14,
    categoria: "Documentos",
    titulo: "Proyecto Centro de Innovación",
    descripcion: "Documento del proyecto.",
    archivo: documentoPDF,
    type: "pdf",
    link: ""
},*/




];

export default proyectos;